<div class="toast-region" aria-live="polite" aria-atomic="true">
  <article
    *ngFor="let toast of toastService.toasts$ | async"
    class="toast"
    [ngClass]="toast.tipo"
    [class.show]="toast.exibindo && !toast.saindo"
    role="alert"
  >
    <div class="toast-icon" aria-hidden="true">!</div>
    <div class="toast-copy">
      <strong>{{ toast.titulo }}</strong>
      <p>{{ toast.mensagem }}</p>
      <div class="toast-progress"><span></span></div>
    </div>
    <button
      type="button"
      class="close"
      (click)="toastService.fechar(toast.id)"
      aria-label="Fechar aviso"
    >
      ×
    </button>
  </article>
</div>
